export default __webpack_public_path__ + "static/media/remove-auth-user-icon.e60d93ad.svg";